import type { ReactNode } from "react";
import { navItems } from "./data";
import { Icon } from "./icons";
export function CrmShell({
  activeRoute,
  onNavigate,
  children,
}: {
  activeRoute: string;
  onNavigate: (route: string) => void;
  children: ReactNode;
}) {
  return (
    <div className="crm-app" data-amazi-id={"crm/src/features/crm/crm-shell.tsx:14:5"}>
      <aside className="sidebar" data-amazi-id={"crm/src/features/crm/crm-shell.tsx:15:7"}>
        <div className="brand" data-amazi-id={"crm/src/features/crm/crm-shell.tsx:16:9"}>
          <div className="brand-mark" data-amazi-id={"crm/src/features/crm/crm-shell.tsx:17:11"}>N</div>
          <span data-amazi-id={"crm/src/features/crm/crm-shell.tsx:18:11"}>ателье</span>
        </div>
        <div className="workspace-label" data-amazi-id={"crm/src/features/crm/crm-shell.tsx:20:9"}>РАБОЧЕЕ ПРОСТРАНСТВО</div>
        <nav data-amazi-id={"crm/src/features/crm/crm-shell.tsx:21:9"}>
          {navItems.map((item) => (
            <button
              className={`nav-item ${activeRoute === item.label ? "active" : ""}`}
              key={item.label}
              onClick={() => onNavigate(item.label)}
             data-amazi-id={"crm/src/features/crm/crm-shell.tsx:23:13"}>
              <Icon name={item.icon} data-amazi-jsx-id={"crm/src/features/crm/crm-shell.tsx:28:15"} />
              <span data-amazi-id={"crm/src/features/crm/crm-shell.tsx:29:15"}>{item.label}</span>
              {item.count && <b data-amazi-id={"crm/src/features/crm/crm-shell.tsx:30:30"}>{item.count}</b>}
            </button>
          ))}
        </nav>
        <div className="sidebar-bottom" data-amazi-id={"crm/src/features/crm/crm-shell.tsx:34:9"}>
          <div className="workspace-label" data-amazi-id={"crm/src/features/crm/crm-shell.tsx:35:11"}>КОМАНДА АТЕЛЬЕ</div>
          <button className="nav-item" onClick={() => onNavigate("Администрирование")} data-amazi-id={"crm/src/features/crm/crm-shell.tsx:36:11"}>
            <Icon name="users" data-amazi-jsx-id={"crm/src/features/crm/crm-shell.tsx:37:13"} />
            <span data-amazi-id={"crm/src/features/crm/crm-shell.tsx:38:13"}>Администрирование</span>
          </button>
          <button
            className="user-card"
            onClick={() => onNavigate("Вход")}
            title="Открыть экран входа"
           data-amazi-id={"crm/src/features/crm/crm-shell.tsx:40:11"}>
            <div className="avatar avatar-purple" data-amazi-id={"crm/src/features/crm/crm-shell.tsx:45:13"}>АК</div>
            <div data-amazi-id={"crm/src/features/crm/crm-shell.tsx:46:13"}>
              <strong data-amazi-id={"crm/src/features/crm/crm-shell.tsx:47:15"}>Анна Крылова</strong>
              <small data-amazi-id={"crm/src/features/crm/crm-shell.tsx:48:15"}>Администратор</small>
            </div>
            <span className="dots" data-amazi-id={"crm/src/features/crm/crm-shell.tsx:50:13"}>•••</span>
          </button>
        </div>
      </aside>
      <main className="main-content" data-amazi-id={"crm/src/features/crm/crm-shell.tsx:54:7"}>{children}</main>
    </div>
  );
}
